import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import type { FamilyCacheState } from '../types'
import type { ResponseMessage } from '@kiddocare-platform/portal-common/base'
import { isCacheValid } from '../../../entry.cache'
import type { Vaccination } from '@kiddocare-platform/portal-common/family'

const addVaccinesKey: CaseReducer<
  FamilyCacheState,
  PayloadAction<{ key: string; value: ResponseMessage<Array<Vaccination>> }>
> = (state, action) => {
  const { key, value } = action.payload
  state.vaccines[key] = { value, cachedAt: Date.now() }
}

const removeVaccinesKey: CaseReducer<FamilyCacheState, PayloadAction<string>> = (state, action) => {
  delete state.vaccines[action.payload]
}

const purgeExpiredVaccinesCache: CaseReducer<FamilyCacheState> = (state) => {
  for (const key of Object.keys(state.vaccines)) {
    if (!isCacheValid(state.vaccines[key])) {
      delete state.vaccines[key]
    }
  }
}

export const vaccinesReducers = {
  addVaccinesKey,
  removeVaccinesKey,
  purgeExpiredVaccinesCache,
}
